<template>
  <el-submenu :index="item.href" v-if="item.children && item.children.length>0" class="el-menu-sub el-menu-each" >
    <template slot="title" style="visibility: hidden"><i :class="item.icon" style="margin-right: 5px;color:#B8C6D7;"></i><span>{{item.name}}</span><div v-if="item.showBadge" style="background-color: red; font-size: 10px; margin-left: 5px; width: 10px; height: 10px; border-radius: 50%;"></div></template>
    <template v-for="child in item.children">
      <sub-menu v-if="child.children && child.children.length>0" :param="child"></sub-menu>
      <el-menu-item :index="child.href"  v-else><i :class="child.icon" style="margin-right: 5px;color:#B8C6D7"></i><span>{{child.name}}</span></el-menu-item>
    </template>
  </el-submenu>
  <el-menu-item :index="item.href" v-else class="el-menu-each" style="display: flex; align-items: center"><i :class="item.icon" style="margin-right: 5px;color:#B8C6D7"></i><span>{{item.name}}</span><div v-if="item.showBadge" style="background-color: red; font-size: 10px; margin-left: 5px; width: 10px; height: 10px; border-radius: 50%;"></div></el-menu-item>
</template>
<script>
  import subMenu from "./subMenu.vue"

  export default {
    name: 'subMenu',
    props: ['param'],
    data: function () {
      return {item: this.param}
    },
    mounted(){
    },
    components: {
      subMenu
    }
  }
</script>
<style lang="stylus" scoped>
</style>
